import { render, staticRenderFns } from "./translationsTour.vue?vue&type=template&id=70e79184&"
import script from "./translationsTour.vue?vue&type=script&lang=js&"
export * from "./translationsTour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports